export default __webpack_public_path__ + "static/media/bgSix.4aebea63.jpg";